import { createSaga } from './saga-helpers';

import * as Api from '../api/tasks-views-api';

const watchGetTasksViews = createSaga({
    type: 'TASKS_VIEWS_FETCH',
    fn: Api.fetchTasksViews,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        tasksViews: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateTasksView = createSaga({
    type: 'TASKS_VIEW_CREATE',
    fn: Api.createTasksView,
    args: action => [action.payload.tasksView],
    successPayload: ({ id: tasksViewId }, action) => ({
        tasksViewId,
        fragment: action.payload.tasksView
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.tasksView
    })
});

const watchUpdateTasksView = createSaga({
    type: 'TASKS_VIEW_UPDATE',
    fn: Api.updateTasksView,
    args: action => [action.payload.tasksViewId, action.payload.tasksViewProps],
    successPayload: tasksView => ({ tasksView })
});

const watchRemoveTasksView = createSaga({
    type: 'TASKS_VIEW_REMOVE',
    fn: Api.removeTasksView,
    args: action => [action.payload.tasksViewId]
});

const sagas = [watchGetTasksViews, watchCreateTasksView, watchUpdateTasksView, watchRemoveTasksView];

export default sagas;
